<template>
  <div>
    <v-dialog v-model="isDialogVisible" persistent max-width="400">
      <v-card>
        <v-card-title class="text-h5 grey lighten-2">
          Evento
        </v-card-title>

        <v-form class="exam pa-3" v-model="isFormValid">
          <section class="">
            <v-text-field
              label="Titulo"
              v-model="examEvent.title"
              :rules="[required()]"
            ></v-text-field>
            <v-textarea
              label="Descripción"
              v-model="examEvent.description"
              :rules="[required()]"
            ></v-textarea>
            <div>
              <span>Tiempo Inicio:</span>
              <input type="datetime-local" v-model="examEvent.range.start" />
            </div>
            <div>
              <span>Tiempo Fin:</span>
              <input type="datetime-local" v-model="examEvent.range.end" />
            </div>
          </section>
        
        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text class="mx-4" @click="isDialogVisible = false">
            Cancelar
          </v-btn>
          <v-btn color="success" @click="save()" :loading="pending" :disabled="!isFormValid">
            Guardar
          </v-btn>
        </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>

    <v-card flat>
      <v-btn dark absolute bottom right fab small @click="showAddDialog()">
        <v-icon aria-label="Agregar evento">mdi-plus</v-icon>
      </v-btn>
      <v-container class="fill-height">
        <v-row class="py-4">
          <strong class="text-h5 font-weight-regular px-2">Eventos</strong>
        </v-row>
      </v-container>
    </v-card>
    <div class="pa-3">
      <v-timeline align-top dense>
        <v-timeline-item small v-for="event of events" :key="event.id">
          <v-card>
            <v-row class="pl-2">
              <v-col cols="3">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <div v-bind="attrs" v-on="on">
                      <strong
                        >Inicio: {{ event.range.start | datetime }}</strong
                      >
                      <div>Duración: {{ event.range | duration }}</div>
                    </div>
                  </template>
                  <span>Fin: {{ event.range.end | datetime }}</span>
                </v-tooltip>
              </v-col>
              <v-col>
                <strong>{{ event.title }}</strong>
                <div class="text-caption">
                  {{ event.description }}
                </div>
              </v-col>
            </v-row>
            <v-card-actions>
              <v-btn text color="primary" @click="showEvent(event)">
                Editar
              </v-btn>
              <v-btn text color="primary" :to="`resultados/${event.id}`">
                Ver resultados
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-timeline-item>
      </v-timeline>
    </div>
  </div>
</template>

<script>
import { event } from "@/services/event";
import { genericErrorHandler } from "@/services/error";

const getEmptyExamEvent = () => ({
  title: "",
  description: "",
  range: {
    start: null,
    end: null,
  },
});

export default {
  data() {
    return {
      events: [],
      isDialogVisible: false,
      examEvent: getEmptyExamEvent(),
      pending:false,
      isFormValid:false,
    };
  },
  mounted() {
    this.loadExamEvents();
  },
  methods: {
    loadExamEvents() {
      return event
        .findAll()
        .then((response) => (this.events = response.data.content));
    },
    showEvent(examEvent) {
      this.isDialogVisible = examEvent;
      this.examEvent = examEvent;
    },
    showAddDialog() {
      this.isDialogVisible = true;
      this.examEvent = getEmptyExamEvent();
    },
    save() {
      this.pending = true;
      event
        .save(this.examEvent)
        .then(() => {
          this.isDialogVisible = false;
          this.examEvent = getEmptyExamEvent();
        })
        .catch(e => {
          this.$swal("Oops...", genericErrorHandler(e), "error");
        })
        .finally(() => this.pending = false)
        .then(() => this.loadExamEvents());
        
    },
    required(msg = 'Campo requerido'){
      return v => !!v || msg
    },
  },
};
</script>

<style></style>
